import React from 'react';

import {
  Button,
  useRefresh,
  useTranslate,
  useUnselectAll,
  useUpdateMany,
} from 'react-admin';

import StarOutlineIcon from '@material-ui/icons/StarOutline';

const UnpinFromTopButton = ({ selectedIds }) => {
	const translate = useTranslate();
	const unselectAll = useUnselectAll("messages");
	const refresh = useRefresh();
	const [updateMany, { loading }] = useUpdateMany(
		"messages",
		selectedIds,
		{
			pin_to_top: false,
		},
		{
			onSuccess: () => {
				refresh(true);
				unselectAll();
			},
		}
	);

	return (
		<Button
			color="secondary"
			onClick={updateMany}
			label={translate("resources.messages.actions.unpin_from_top")}
			disabled={loading}
		>
			<StarOutlineIcon />
		</Button>
	);
};

export default UnpinFromTopButton;
